import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '@API/axiosNeatex';
import type { InvUpdateCostModels, InvUpdateCostByIdModels } from './InvUpdateCostModels';
// import { TransactionTypesModels } from '../SharedModels';

export const addUpdateCostTransactions = createAsyncThunk(
  'InvUpdateCost/addUpdateCostTransactions',
  async (item: any, { rejectWithValue }) => {
    try {
      // console.log(JSON.stringify(item));

      // debugger
      const { data } = await ntxAPI.post('InvUpdateCost/AddUpdateCostTransactions', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateUpdateCostTransactions = createAsyncThunk(
  'InvUpdateCost/updateUpdateCostTransactions',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('InvUpdateCost/UpdateUpdateCostTransactions', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTransactionsUpdateCostList = createAsyncThunk(
  'InvUpdateCost/getTransactionsUpdateCostList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('InvUpdateCost/GetTransactionsUpdateCostList');
      if (data?.succeeded) {
        //===
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getUpdateCostTransactionsById = createAsyncThunk(
  'InvUpdateCost/getUpdateCostTransactionsById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`InvUpdateCost/GetUpdateCostTransactionsById?Id=${id}`);
      if (data?.succeeded) {
        // ===
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  UpdateCostList: InvUpdateCostModels[];
  UpdateCostById: InvUpdateCostByIdModels;
  loading: boolean;
  error: any | null;
} = {
  UpdateCostList: [],
  UpdateCostById: {} as InvUpdateCostByIdModels,
  loading: false,
  error: null,
};

const InvUpdateCostSlice = createSlice({
  name: 'InvUpdateCost',
  initialState,
  reducers: {
    // cleanUpTransactionsQuotationById: (state) => {
    //   state.TransactionsQuotationById = {} as InvUpdateCostByIdModels;
    // },
  },
  extraReducers(builder) {
    builder

      .addCase(getTransactionsUpdateCostList.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getTransactionsUpdateCostList.fulfilled,
        (state, action: PayloadAction<InvUpdateCostModels[]>) => {
          state.loading = false;
          state.UpdateCostList = action.payload;
        }
      )
      .addCase(getTransactionsUpdateCostList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //!~~~~~~~~~~~~~~~~~~

  

      .addCase(getUpdateCostTransactionsById.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getUpdateCostTransactionsById.fulfilled,
        (state, action: PayloadAction<InvUpdateCostByIdModels>) => {
          state.loading = false;
          state.UpdateCostById = action.payload;
        }
      )
      .addCase(getUpdateCostTransactionsById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default InvUpdateCostSlice.reducer;
